import APIService from '@/services/APIService.js';

export default {
  getById(id) {
    return APIService.apiCall().get(`/taxasMediasDepreciacao/getById/${id}`);
  },
  getAll() {
    return APIService.apiCall().get('/taxasMediasDepreciacao/getAll');
  },
  deletar(id) {
    return APIService.apiCall().get(`/taxasMediasDepreciacao/excluir/${id}`);
  },
  executar(id) {
    return APIService.apiCall().get(`/taxasMediasDepreciacao/executar/${id}`);
  },
  salvar(postData, id) {
    return APIService.apiCall().post(`/taxasMediasDepreciacao/salvar/${id}`, JSON.stringify(postData));
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/taxasMediasDepreciacao/baixar/${id}`, {
      responseType: 'blob',
      ...config
    });
  }
};
